export enum CustomerAction {
    Activate = "ACTIVATE",
    Deactivate = "DEACTIVATE",
    Block = "BLOCK",
    Unblock = "UNBLOCK",
}
